import { Base } from './base';

export class Address extends Base {
  email: string;
  address_line1: string;
  address_line2: string;
  zipcode: string;
  city: string;
  country: string;
  shipping_address_line1: string;
  shipping_address_line2: string;
  shipping_zipcode: string;
  shipping_city: string;
  shipping_country: string;

  required = ['address_line1', 'zipcode', 'city', 'country', 'email'];

  isValid(): boolean {
    // for now just check if all required fields are filled in
    for (let fld of this.required) {
      if (!this[fld]) {
        return false;
      }
    }
    return true;
  }

  copyPostalToShipping(): void {
    // copy the postal fields to the matching shipping ones
    this.shipping_address_line1 = this.address_line1;
    this.shipping_address_line2 = this.address_line2;
    this.shipping_zipcode = this.zipcode;
    this.shipping_city = this.city;
    this.shipping_country = this.country;
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/address.ts